export const comparatorData = {
    "addressField": [
        { label: "contains", value: "contains"},
        { label: "does not contain", value: "doesNotcontain"},
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"}
    ],
    "attachment": [
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"}
    ],
    "checkboxField": [
        { label: "checked", value: "on"},
        { label: "unchecked", value: "off"}
    ],
    "inputForm": [
        { label: "equals", value: "isEqualTo" },
        { label: "not equals", value: "isNotEqualTo"},
        { label: "contains", value: "contains"},
        { label: "does not contain", value: "doesNotcontain"},
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"},
        { label: "character length equals", value: "charEquals"},
        { label: "character length greater than or euqual to", value: "charLengthGreaterThanOrEqualTo"},
        { label: "character length less than or equal to", value: "charLengthLessThanOrEqualTo"}

    ],
    "textAreaForm": [
        { label: "equals", value: "isEqualTo" },
        { label: "not equals", value: "notEqual"},
        { label: "contains", value: "contains"},
        { label: "does not contain", value: "doesNotcontain"},
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"}
    ],
    "dateForm": [
        { label: "is today", value: "isToday" },
        { label: "is before", value: "isBefore"},
        { label: "is after", value: "isAfter"},
        { label: "before or equal to", value: "beforeOrEqualTo"},
        { label: "after or equal to", value: "afterOrEqualTo"},
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"},
    ],
    "dropdownField": [
        { label: "equals", value: "isEqualTo"},
        { label: "not equals", value: "isNotEqualTo"},
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"},
        { label: "contains all of", value: "containsAllOf"},
        { label: "contains any of", value: "containsAnyOf"},
    ],
    "imageForm": [
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"}
    ],
    "radioField": [
        { label: "equals", value: "isEqualTo"},
        { label: "not equals", value: "isNotEqualTo"},
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"}
    ],
    "switchForm": [
        { label: "on", value: "on" },
        { label: "off", value: "off" }
    ],
    "contactField": [
        { label: "contains", value: "contains" },
        { label: "does not contain", value: "doesNotcontain" },
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"},
        { label: "character length equals", value: "charEquals"},
        { label: "character length greater than or euqual to", value: "charLengthGreaterThanOrEqualTo"},
        { label: "character length less than or equal to", value: "charLengthLessThanOrEqualTo"}
    ],
    "multipleChoiceField": [
        // { label: "equals", value: "isEqualTo"},
        // { label: "not equals", value: "isNotEqualTo"},
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"},
        { label: "contains", value: "contains"},
        { label: "does not contain", value: "doesNotcontain"},   
        { label: "contains all of", value: "containsAllOf"},
        { label: "contains any of", value: "containsAnyOf"},     
    ],
    "numberForm": [
        { label: "equals", value: "isEqualTo"},
        { label: "not equals", value: "isNotEqualTo"},
        { label: "less than", value: "lessThan"},
        { label: "greater than", value: "greaterThan"},
        { label: "less than or equal to", value: "lessThanOrEqualTo"},
        { label: "greater than or equal to", value: "greaterThanOrEqualTo"},
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"},
        { label: "is even", value: "isEven"},
        { label: "is odd", value: "isOdd"},
        { label: "character length equals", value: "charEquals"},
        { label: "character length greater than or euqual to", value: "charLengthGreaterThanOrEqualTo"},
        { label: "character length less than or equal to", value: "charLengthLessThanOrEqualTo"}
    ],
    "timeForm": [
        { label: "is before", value: "isBefore" },
        { label: "is after", value: "isAfter"},
        { label: "before or equal to", value: "beforeOrEqualTo"},
        { label: "after or equal to", value: "afterOrEqualTo"},
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"},

    ],
    "linkField": [
        { label: "contains", value: "contains" },
        { label: "does not contain", value: "doesNotcontain" },
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"},
    ],
    "workflowStep": [
        { label: "equals", value: "isEqualTo"},
        { label: "not equals", value: "isNotEqualTo"}
    ],
    "connectedUser": [
        { label: "contained in", value: "containedIn"}
    ],
    "userForm": [
        { label: "contains any of", value: "containsAnyOf" },
        { label: "does not contain", value: "doesNotcontain" },
        { label: "is empty", value: "isEmpty"},
        { label: "is not empty", value: "isNotEmpty"}
    ]
}